const IN_APP_NAV_KEY = 'TYPIX_HAS_IN_APP_NAV';

export function markInAppNavigation() {
  try {
    sessionStorage.setItem(IN_APP_NAV_KEY, '1');
  } catch {
 
  }
}

export function hasInAppNavigation() {
  try {
    return sessionStorage.getItem(IN_APP_NAV_KEY) === '1';
  } catch {
    return false;
  }
}

export function consumeCameFromLogin(locationState) {
  let cameFromLogin = Boolean(locationState?.fromLogin);
  try {
    cameFromLogin = cameFromLogin || sessionStorage.getItem('cameFromLogin') === '1';
    if (cameFromLogin) sessionStorage.removeItem('cameFromLogin');
  } catch {
 
  }
  return cameFromLogin;
}
 
export function navigateBackOrDashboard(history, dashboardPath, locationState) {
  if (!history || !dashboardPath) return;

  if (consumeCameFromLogin(locationState) || !hasInAppNavigation()) {
    history.replace(dashboardPath);
    return;
  }

  history.goBack();
}
